import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from '#app/composables/router';
import { useStore } from '#imports';
import { isSpaceRoute } from '#layers/spaces/utils/routes';
import { translateSpace } from '#layers/spaces/utils/space';

export function useCurrentSpace() {
	const i18n = useI18n();
	const store = useStore();
	const route = useRoute();

	const spaceRoute = computed(() => route.matched.find((route) => isSpaceRoute(route)));
	const currentSpaceId = computed(() => spaceRoute.value?.name as string | undefined);

	const { data: currentSpace } = store.MonospaceSpace.query((q) => q.first(currentSpaceId.value
		? {
				key: currentSpaceId.value,
				include: {
					pages: true,
					sections: true,
				},
			}
		: { enabled: false }));

	const currentSpaceTranslated = computed(() => currentSpace.value ? translateSpace(currentSpace.value, i18n) : null);

	return {
		currentSpace,
		currentSpaceTranslated,
	};
}
